import { AnyAction } from "redux";
import { handleActions } from "redux-actions";
import actionTypes from "./actions";
import { ContextualRecommendationsReducerInterface } from "./types";

const INIT_STATE: ContextualRecommendationsReducerInterface = {
    contextualRecommendations: [],
    isContextRecomModalOpen: false,
    isContextualRecomLoding: false,
    isContextualApiFail: undefined,
    contextualRecommendationsSerp: [],
    contextualRecommendationsBusiComp: [],
    isContextualRecomSerpLoding: false,
    isContextualRecomBusiCompLoding: false,
    isContextualRecomScoreLoding: false,
    isContextualRecomSerpScoreLoding: false,
    isContextualRecomBusiCompScoreLoding: false,
    currentElementKey: undefined
};

const ContextualRecommendationReducer = handleActions(
    {

        [actionTypes.SET_CONTEXTUAL_RECOMMENDATION]: (state, action: AnyAction) => ({
            ...state,
            contextualRecommendations: action.payload,
            isContextualRecomLoding: false
        }),
        [actionTypes.SET_CONTEXTUAL_RECOMMENDATION_MODAL_OPEN]: (state, action: AnyAction) => ({
            ...state,
            isContextRecomModalOpen: action.payload
        }),
        [actionTypes.CALL_CONTEXTUAL_RECOMMENDATION_INITIATE]: (state, action: AnyAction) => ({
            ...state,
            currentElementKey: action.payload?.elementKey,
        }),
        [actionTypes.CALL_CONTEXTUAL_RECOMMENDATION]: (state, action: AnyAction) => ({
            ...state,
            isContextualRecomLoding: true,
            isContextualRecomSerpLoding: true,
            isContextualRecomBusiCompLoding: true,
            isContextualRecomScoreLoding: true,
            isContextualRecomSerpScoreLoding: true,
            isContextualRecomBusiCompScoreLoding: true,
            isContextualApiFail: undefined
        }),
        [actionTypes.SET_CONTEXTUAL_RECOMMENDATION_API_FAIL]: (state, action: AnyAction) => ({
            ...state,
            isContextualApiFail: action.payload
        }),
        [actionTypes.SET_CONTEXTUAL_RECOMMENDATION_SERP]: (state, action: AnyAction) => ({
            ...state,
            contextualRecommendationsSerp: action.payload,
            isContextualRecomSerpLoding: false
        }),
        [actionTypes.SET_CONTEXTUAL_RECOMMENDATION_BUSI_COMP]: (state, action: AnyAction) => ({
            ...state,
            contextualRecommendationsBusiComp: action.payload,
            isContextualRecomBusiCompLoding: false
        }),
        [actionTypes.SET_CONTEXTUAL_RECOMMENDATION_SCORE_LOADING]: (state, action: AnyAction) => ({
            ...state,
            ...(action.payload.keywordFocus !== undefined && { isContextualRecomScoreLoding: action.payload.keywordFocus }),
            ...(action.payload.serpDriven !== undefined && { isContextualRecomSerpScoreLoding: action.payload.serpDriven }),
            ...(action.payload.competitorDriven !== undefined && { isContextualRecomBusiCompScoreLoding: action.payload.competitorDriven })
        }),
        [actionTypes.RESET_CURRENT_ELEMENT_KEY]: (state, action: AnyAction) => ({
            ...state,
            currentElementKey: undefined
        })
    },
    INIT_STATE);

export default ContextualRecommendationReducer;
